import AssignedCaseDetail from '../shared/AssignedCaseDetail';

export default function CEOEscalationDetail() {
  return <AssignedCaseDetail basePath="/hcms/ceo-escalations" title="Escalated Ticket" />;
}
